import Component from '../colorz/Component';

export default class WhereToBuy extends Component {
	static selectors = {
		el: '.js-where-to-buy',
		btn: '.js-buy-online-button',
		expandBtn: '[data-expandable-btn]',
		expandWrapper: '[data-expandable-wrapper]',
	};

	static hash = '#wheretobuy';
	static panelId = 'wheretobuy';

	onInit(el) {
		this.handleClick = this.handleClick.bind(this);
		this.handleHashChange = this.handleHashChange.bind(this);

		this.el = el;
		this.openRetryMax = 40;
		this.openRetryDelay = 100;
	}

	onReady() {
		document.addEventListener('click', this.handleClick);
		window.addEventListener('hashchange', this.handleHashChange);

		this.normalizeHash();
		this.openIfHash();
	}

	onLoad() {
		this.normalizeHash();
		this.openIfHash();
	}

	hasWhereToBuyHash() {
		return window.location.hash.toLowerCase().includes('wheretobuy');
	}

	normalizeHash() {
		if (!this.hasWhereToBuyHash()) return;

		const cleanUrl = `${window.location.pathname}${window.location.search}${WhereToBuy.hash}`;

		if (window.location.hash !== WhereToBuy.hash) {
			history.replaceState(null, '', cleanUrl);
		}
	}

	openPanel(attempt = 0) {
		const panel = this.el.querySelector(`#${WhereToBuy.panelId}`);

		if (!panel) {
			if (attempt < this.openRetryMax) {
				setTimeout(() => this.openPanel(attempt + 1), this.openRetryDelay);
			}
			return;
		}

		this.elExpandBtn = panel.querySelector(WhereToBuy.selectors.expandBtn);
		this.elExpand = panel.querySelector(WhereToBuy.selectors.expandWrapper);

		if (!this.elExpandBtn || !this.elExpand) {
			return console.error('WhereToBuy: missing elements');
		}

		this.elExpandBtn.classList.add('is-open');
		this.elExpandBtn.setAttribute('aria-expanded', 'true');
		this.elExpand.classList.add('is-open');

		panel.scrollIntoView({
			behavior: 'smooth',
			block: 'start',
		});
	}

	openIfHash() {
		if (!this.hasWhereToBuyHash()) return;

		this.normalizeHash();
		this.openPanel();
	}

	handleHashChange() {
		this.openIfHash();
	}

	handleClick(event) {
		const link = event.target.closest(WhereToBuy.selectors.btn);
		if (!link) return;

		const href = link.getAttribute('href');
		if (!href) return;

		const targetHref = this.buildWhereToBuyHref(href);
		if (link.getAttribute('href') !== targetHref) {
			link.setAttribute('href', targetHref);
		}

		if (!this.isSameProductPage(targetHref)) return;

		event.preventDefault();
		this.openPanel();

		const cleanUrl = `${window.location.pathname}${window.location.search}${WhereToBuy.hash}`;
		if (
			`${window.location.pathname}${window.location.search}${window.location.hash}` !==
			cleanUrl
		) {
			history.pushState(null, '', cleanUrl);
		}
	}

	buildWhereToBuyHref(href) {
		return `${this.stripHash(href)}${WhereToBuy.hash}`;
	}

	stripHash(href) {
		try {
			const url = new URL(href, window.location.href);
			url.hash = '';
			return url.href;
		} catch {
			return href.split('#')[0];
		}
	}

	isSameProductPage(href) {
		try {
			const target = new URL(href, window.location.href);
			const current = new URL(window.location.href);

			return (
				target.hostname === current.hostname &&
				this.normalizePath(target.pathname) ===
					this.normalizePath(current.pathname) &&
				target.search === current.search
			);
		} catch {
			return false;
		}
	}

	normalizePath(pathname) {
		return pathname.replace(/\/$/, '') || '/';
	}
}
